import request, { METHOD, requestSet } from '@/utils/request'

// 查询列表-工单信息
export function apiMesDiscreteJobsList (query) {
  return request({
    url: '/mes/mesDiscreteJobs/list',
    method: 'get',
    params: query
  })
}

// 查询列表-打印五金工单获取信息
export function apiGetHardwarePrintDetail (query) {
  return request({
    url: '/mes/mesDispatch/getHardwarePrintDetail',
    method: 'get',
    params: query
  })
}

// 根据工单用料ID获取发起的物料信息
export function apiGetMaterialInfoByRequirementIds (data) {
  return request({
    url: '/mes/mesDiscreteJobs/getMaterialInfoByRequirementIds',
    method: 'post',
    data: data
  })
}

// 根据工单用料ID获取发起的物料信息
export function apiSubmitChangeItem (data) {
  return request({
    url: '/mes/mesDiscreteJobs/submitChangeItem',
    method: 'post',
    data: data
  })
}

// 校验当前工单的考核交期是否可以提交
export function apiCheckAssessmentDeliveryDateCanSubmit (data) {
  return request({
    url: '/mes/mesDiscreteJobs/checkAssessmentDeliveryDateCanSubmit',
    method: 'post',
    data: data
  })
}

// 新增-工单信息
export function apiMesDiscreteJobsAdd (data) {
  return request({
    url: '/mes/mesDiscreteJobs',
    method: 'post',
    data: data
  })
}

// 导出工单工作台列表
export function apiMesDiscreteJobsExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/v2/export',
    method: 'post',
    data: data
  })
}

// 关联工单导出
export function apiAssociatedWorkOrderExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/associatedWorkOrder/v2/export',
    method: 'post',
    data: data
  })
}

// 工单用料
export function apiMesRequirementOperationsExport (data) {
  return request({
    url: '/mes/mesRequirementOperations/v2/export',
    method: 'post',
    data: data
  })
}

// 工单工序
export function apiMesOperationsExport (data) {
  return request({
    url: '/mes/mesOperations/v2/export',
    method: 'post',
    data: data
  })
}

// 修改工单用料中的物料数据
export function apiMesEditMaterial (data) {
  return request({
    url: `/mes/mesRequirementOperations/editMaterial`,
    method: 'post',
    data: data
  })
}

// 修改工单用料中的物料用料数据
export function apiMesEditQuantityPerAssembly (data) {
  return request({
    url: `/mes/mesRequirementOperations/editQuantityPerAssembly`,
    method: 'post',
    data: data
  })
}

// 批量更新数据
export function apiUpdateBatchData (data) {
  return request({
    url: `/mes/mesDiscreteJobs/updateBatchData`,
    method: 'post',
    data: data
  })
}

// 修改-工单信息
export function apiMesDiscreteJobsUpdate (data) {
  return request({
    url: '/mes/mesDiscreteJobs',
    method: 'put',
    data: data
  })
}

// 下达
export function apiMesDiscreteJobsRelease (data) {
  return request({
    url: '/mes/mesDiscreteJobs/release',
    method: 'put',
    data: data
  })
}

// 撤回
export function apiMesDiscreteJobsWithdraw (data) {
  return request({
    url: '/mes/mesDiscreteJobs/withdraw',
    method: 'put',
    data: data
  })
}

// 异常完工
export function apiMesDiscreteJobsAbnormalCompletion (data) {
  return request({
    url: '/mes/mesDiscreteJobs/abnormalCompletion',
    method: 'put',
    data: data
  })
}

// 查询列表-工单用料表
export function apiMesRequirementOperationsList (query) {
  return request({
    url: '/mes/mesRequirementOperations/list',
    method: 'get',
    params: query
  })
}

// 获取工单分仓数量
export function apiMesGetDivideWarehouseQty (query) {
  return request({
    url: '/mes/mesDiscreteJobs/getDivideWarehouseQty',
    method: 'get',
    params: query
  })
}

// 修改工单的目的仓数据
export function apiUpdateDestinationQty (data) {
  return request({
    url: `/mes/mesDiscreteJobs/updateDestinationQty`,
    method: 'post',
    data: data
  })
}

// 线边仓倒冲领料
export function apiXbcBackFlushMaterialIssuance ({ datasource }) {
  return request({
    url: `/mes/mesDiscreteJobs/xbcBackFlushMaterialIssuance`,
    method: 'post',
    data: { datasource }
  })
}

// 查询列表-工单用料表
export function apiMesOperationsList (query) {
  return request({
    url: '/mes/mesOperations/list',
    method: 'get',
    params: query
  })
}

// 查询列表-关联工单
export function apiMesDiscreteJobsAssociatedWorkOrderList (query) {
  return request({
    url: '/mes/mesDiscreteJobs/associatedWorkOrderList',
    method: 'get',
    params: query
  })
}

// 下拉框-车间
export function apiMesDiscreteJobsWorkCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/workCodeBox',
    method: 'get',
    params: query
  })
}

// 下拉框-产线
export function apiMesDiscreteJobsLineCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/lineCodeBox',
    method: 'get',
    params: query
  })
}

// 下拉框-工单分类
export function apiMesDiscreteJobsClassCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/classCodeBox',
    method: 'get',
    params: query
  })
}

// 下拉框-工单类型
export function apiMesDiscreteJobsClassCodeToType (query) {
  return request({
    url: '/mes/mesDiscreteJobs/classCodeToType',
    method: 'get',
    params: query
  })
}

// 下载模板
export function apiMesDiscreteJobsTemplate (data) {
  return request({
    url: '/mes/mesDiscreteJobs/template',
    method: 'post',
    data: data
  })
}

// 工单批量导入关闭
export async function apiBatchCloseImport(params) {
  return requestSet(`/mes/mesDiscreteJobs/batchCloseImport`, METHOD.POST, params, { responseType: "blob" });
}

// 根据工单ids查询关联工单工作台列表
export function apiGetAssessmentDeliveryDateUpdateList (data, loadAssociateWorkOrderIs) {
  return request({
    url: `/mes/mesDiscreteJobs/getAssessmentDeliveryDateUpdateList?loadAssociateWorkOrderIs=${loadAssociateWorkOrderIs}`,
    method: 'post',
    data: data
  })
}

// 工单工作台提交工单考核交期变更审批
export function apiSubmitAssessmentDeliveryDateUpdate (data) {
  return request({
    url: `/mes/mesDiscreteJobs/submitAssessmentDeliveryDateUpdate`,
    method: 'post',
    data: data
  })
}

// 工单派工提交工单考核交期变更审批
export function apiMesDispatchAssessmentDeliveryDateUpdate (data) {
  return request({
    url: `/mes/mesDispatch/submitAssessmentDeliveryDateUpdate`,
    method: 'post',
    data: data
  })
}

// 取消
export function apiMesDiscreteJobsCancellation (data) {
  return request({
    url: `/mes/mesDiscreteJobs/cancellation`,
    method: 'post',
    data: data
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 查询工单工作台日志
export function apiMesSelectMesWipLogList (query) {
  return request({
    url: '/mes/mesWipLog/selectMesWipLogList',
    method: 'get',
    params: query
  })
}

// 获取物料的包装bom版本
export function apiMesGetItemPackageVersion (query) {
  return request({
    url: '/mes/mesDiscreteJobs/getItemPackageVersion',
    method: 'get',
    params: query
  })
}

// 修改目的仓
export function apiBatchUpdateDestination (data) {
  return request({
    url: `/mes/mesDiscreteJobs/batchUpdateDestination`,
    method: 'post',
    data: data
  })
}

// 工单派工-刷新工单的包装bom版本
export function apiWorkOrderSentRefreshVersion (data) {
  return request({
    url: `/mes/mesDispatch/refreshPackageVersion`,
    method: 'post',
    data: data
  })
}

// 工单工作台-刷新工单的包装bom版本
export function apiWorkOrderDeskRefreshVersion (data) {
  return request({
    url: `/mes/mesDiscreteJobs/refreshPackageVersion`,
    method: 'post',
    data: data
  })
}

// 联动上级工单时间
export function apiWorkOrderDeskLinkageSuperTime (data) {
  return request({
    url: `/mes/mesDiscreteJobs/linkageSuperTime`,
    method: 'post',
    data: data
  })
}
